import { createStoreContext } from 'ariakit-utils/store';
var TabContext = createStoreContext();
export { TabContext as T };